/**
 *
 * Group Filter View.
 * Filters divs by clicking buttons through matching identifiers.
 * NB: Uses [data-sw-group-filter-show-all] and [data-sw-group-filter-element] for the filtering buttons,
 * and should have a data-{} attribute with a matching value for data-sw-group-filter-element.
 *
 */

var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');
var _ = require('underscore');
var FILTER_TYPE_UNION = "union";
var FILTER_TYPE_INTERSECTION = "intersection";
var FILTER_TYPE_SINGLE = "single";

var GroupFilter = ShapewaysView.extend({
  events: {
    'click [data-sw-group-filter-show-all]': 'displayAll',
    'click [data-sw-group-filter-element]': 'filter'
  },

  swAttrs: {
    filterElement: 'data-sw-group-filter-element',
    filterType: 'data-sw-group-filter-type'
  },

  initialize: function(options) {
    // Settings for the selector elements.
    this.selectedClass = options.selectedClass;

    // Settings for the groups to be filtered.
    this.groupIdAttrName = options.groupIdAttrName;

    // Flag for whether display all is currently selected.
    this.displayAllActive = true;

    // Type of filter logic to apply: union or intersection
    this.filterType = $('.sw-group-filter').attr(this.swAttrs.filterType);

    // Create cache for reusable jQuery elements.
    this.cacheElements('[data-sw-group-filter-element]', '$filterButtons');
    this.cacheElements('[data-sw-group-filter-show-all]', '$showAllButton');
  },

  /**
   * Displays all the elements.
   */
  displayAll: function() {
    this.cachedElements.$filterButtons.removeClass(this.selectedClass);

    // Use selector instead of target here because displayAll can be called
    // when every filter is selected and no groups are displayed.
    this.cachedElements.$showAllButton.addClass(this.selectedClass);
    $('[' + this.groupIdAttrName + ']').swShow();

    this.displayAllActive = true;
  },

  /**
   * Filters when a filter element is clicked.
   */
  filter: function(e) {
    if (this.displayAllActive) {
      this.clearAll();
    }

    var thisTarget = e.target;
    var targetId = thisTarget.getAttribute(this.swAttrs.filterElement);

    if(this.filterType === FILTER_TYPE_SINGLE) {
      // Hide all groups, unselect all filters
      this.hideAllGroups();
      this.$('.' + this.selectedClass).removeClass(this.selectedClass);

      // Select this filter, show this group
      thisTarget.classList.add(this.selectedClass);
      this.showGroup(targetId);

    } else {
      if(thisTarget.classList.contains(this.selectedClass)) {
        thisTarget.classList.remove(this.selectedClass);
        this.hideGroup(targetId);
      } else {
        thisTarget.classList.add(this.selectedClass);
        this.showGroup(targetId);
      }
    }

    this.checkSelected();
  },

  /**
   * Clears all elements if the filter was triggered after
   * display all was selected.
   */
  clearAll: function() {
    if (this.displayAllActive) {
      $('[' + this.groupIdAttrName + ']').swHide();
      this.cachedElements.$showAllButton.removeClass(this.selectedClass);
      this.displayAllActive = false;
    }
  },

  /**
   * Gets all selected Elements
   * @return {Array}
   */
  getSelectedIds: function() {
    // Determine all selected groups
    var selectedIds = [];
    var self = this;
    $('.' + this.selectedClass).each(function() {
      selectedIds.push(parseInt($(this).attr(self.swAttrs.filterElement),10));
    });
    return selectedIds;
  },

  getGroupElementsByGroupId: function(groupId) {
    var that = this;
    var $groupElements = $('[' + this.groupIdAttrName + ']');

    var $filteredElements = $groupElements.filter(function(){
      var groupIds = JSON.parse($(this).attr(that.groupIdAttrName));

      if($.isArray(groupIds) && groupIds.indexOf(parseInt(groupId, 10)) !== -1) {
        return true;
      }

      if(parseInt(groupId, 10) === groupIds) {
        return true;
      }

      return false;
    });

    return $filteredElements;
  },

  /**
   * Displays groups based on a matching data attributes value.
   */
  showGroup: function(groupId) {
    var self = this;
    if ( (this.filterType === FILTER_TYPE_UNION) || (this.filterType === FILTER_TYPE_SINGLE) ) {
      this.getGroupElementsByGroupId(groupId).swShow();
    } else if (this.filterType === FILTER_TYPE_INTERSECTION) {
      $('[' + this.groupIdAttrName + ']').each( function(element) {
        var displayThis = true;
        var elementIds = JSON.parse($(element).attr(self.groupIdAttrName));
        displayThis = _.find(elementIds, function(categoryId){ return _.indexOf(elementIds, categoryId) === -1; });
        if (displayThis) {
          $(element).swShow();
        } else {
          $(element).swHide();
        }
      });
    }
  },

  /**
   * Hides groups based on a matching data attributes value.
   */
  hideGroup: function(groupId) {

    var selectedIds = this.getSelectedIds();

    // Hide all matching elements
    this.getGroupElementsByGroupId(groupId).swHide();

    // Show all elements which still have selected categories
    _.each(selectedIds, function (id) {
      this.showGroup(id);
    }, this);
  },

  /**
   * Hides all groups
   */
  hideAllGroups: function() {
    $('[' + this.groupIdAttrName + ']').swHide();
  },

  /**
   * Checks to see if everything is being filtered and displays
   * all to avoid showing no content.
   */
  checkSelected: function() {
    var selected = document.getElementsByClassName(this.selectedClass);
    if (!selected.length) {
      this.displayAll();
    }
  }
});

module.exports = GroupFilter;
